import type { Geolocation } from "."

export const isGeolocationPosition = (
  subject: unknown
): subject is Geolocation.Position => {
  if (typeof subject !== `string`) {
    return false
  }
  const parts = subject.split(`,`)
  if (parts.length !== 2) {
    return false
  }
  if (
    parts.some((part): boolean => {
      return Number.isNaN(Number(part))
    })
  ) {
    return false
  }

  return true
}
